import React from 'react';
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';
import {
  FaSearch,
  FaUserPlus,
} from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { mask } from '~/Utils/Helpers';

var colunasProspecto = [
  {
    title: 'Código',
    key: 'codigo',
    ordenacao: true,
    align: 'center',
    width: '80px',
  },
  {
    title: 'CPF/CNPJ',
    key: 'cpf',
    ordenacao: false,
    align: 'center',
    width: '130px',
  },
  {
    title: 'Nome',
    key: 'nome',
    ordenacao: true,
    align: 'left',
  },
  {
    title: 'Na fila',
    key: 'codigo_ativo',
    ordenacao: false,
    align: 'center',
    width: '120px',
    render: function (value, item) {
      if (value) {
        return 'QD ' + (item.mapa1 || '-') + ' / LT ' + (item.mapa2 || '-');
      }
      return 'Não';
    },
  },
];

export default function IncluirProspectoSection(props) {
  var cpfBusca = props.cpfBusca;
  var setCpfBusca = props.setCpfBusca;
  var prospectos = props.prospectos;
  var isLoadingProspecto = props.isLoadingProspecto;
  var onBuscar = props.onBuscar;
  var onIncluir = props.onIncluir;

  return (
    <Card className="mt-4 shadow-sm" style={{ borderRadius: 8, overflow: 'hidden' }}>
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', borderRadius: 0 }}>
        <strong>
          <FaUserPlus className="mr-1" />
          Incluir prospecto na fila
        </strong>
      </Card.Header>
      <Card.Body>
        <Row className="align-items-end">
          <Col md={4}>
            <Form.Group className="mb-0">
              <Form.Label>Buscar prospecto por CPF/CNPJ</Form.Label>
              <MaskedInput
                mask={mask.cpf_cnpj}
                guide={false}
                className="form-control"
                placeholder="Informe o CPF ou CNPJ"
                value={cpfBusca}
                onChange={function (e) {
                  var val = e && e.target ? e.target.value : '';
                  setCpfBusca(val);
                }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Button
              variant="primary"
              disabled={isLoadingProspecto}
              onClick={onBuscar}
            >
              {isLoadingProspecto ? (
                <Spinner as="span" animation="border" size="sm" />
              ) : (
                <>
                  <FaSearch className="mr-1" />
                  Buscar
                </>
              )}
            </Button>
          </Col>
        </Row>

        {prospectos.length > 0 && (
          <div className="mt-3">
            <Tabela
              colunas={colunasProspecto}
              dados={prospectos}
              action={true}
              acoes={[
                {
                  icon: <FaUserPlus />,
                  label: 'Incluir',
                  type: 'success',
                  onClick: function (item) { onIncluir(item); },
                },
              ]}
              fontSize="13px"
              striped={true}
              hover={true}
            />
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
